<template>
  <AccessHandler
    :requiredRoleGroups="roleGroups"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <div class="rc-rfr-contacts-page" data-cy="rc-rfr-contacts-page">
    <MasterPage>
      <template v-if="hasAccess" v-slot:content>
        <header class="page__header--container clearfix">
          <h1 class="page__title--text pull-left" data-cy="page-title">
            RC AND RFR CONTACTS
          </h1>
        </header>
        <RcRfrContactsView />
        <GlobalFooter />
      </template>
    </MasterPage>
  </div>
</template>

<script setup lang="ts">
import MasterPage from "../MasterPage.vue";
import GlobalFooter from "@/views/GlobalFooter.vue";
import RcRfrContactsView from "@/views/rcRfrContacts/RcRfrContactsView.vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import { type RoleGroup, RfrContactsGroup } from "@/shared/access/RoleGroups";
import { ref } from "vue";

const roleGroups = [RfrContactsGroup] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>
